import values from 'lodash/values'
import some from 'lodash/some'
import orderBy from 'lodash/orderBy'
import pick from 'lodash/pick'
import isString from 'lodash/isString'
import {
  compose,
  withStateHandlers,
  withProps,
  lifecycle,
} from 'recompose'

const defaultAmountOptions = [
  {
    label: '10 rows',
    value: 10,
  },
  {
    label: '20 rows',
    value: 20,
  },
  {
    label: '50 rows',
    value: 50,
  },
  {
    label: '100 rows',
    value: 100,
  },
]

const findPageData = (data, itemsPerPage, currentPage) => {
  return data.slice(itemsPerPage * currentPage, (itemsPerPage * currentPage) + itemsPerPage)
}

const orderDataByKey = (data, sortKey, sortType = 'asc') => {
  if (!sortKey) {
    return data
  }
  return orderBy(data, [sortKey], [sortType])
}

const filteredDataFromKeyword = (data, keyword, config) => {
  return data.filter((item) => {
    const validConfig = config.filter(({ accessor }) => !!accessor).map(({ accessor }) => accessor)
    const filteredItem = pick(item, validConfig)
    return some(values(filteredItem), (value) => {
      return isString(value) && value.toLowerCase().includes(keyword.toLowerCase())
    })
  })
}

export default () => compose(
  withStateHandlers(
    ({ rawData, amountOptions, defaultSortKey, defaultSortType }) => ({
      currentPage: 0,
      itemsPerPage: amountOptions ? amountOptions[0].value : defaultAmountOptions[0].value,
      data: orderDataByKey(rawData, defaultSortKey, defaultSortType),
      keyword: '',
      sortKey: defaultSortKey || '',
      sortType: defaultSortType,
    }),
    {
      refreshData: () => (data) => ({
        data,
      }),
      setCurrentPage: () => (currentPage) => ({
        currentPage,
      }),
      onAmountOptionChange: () => (itemsPerPage) => ({
        currentPage: 0,
        itemsPerPage,
      }),
      onKeywordChange: ({ data }, { rawData, config }) => (val) => ({
        currentPage: 0,
        data: val ? (
          filteredDataFromKeyword(
            data,
            val,
            config,
          )
        ) : rawData,
        keyword: val,
      }),
      clearKeyword: (_, { rawData }) => () => ({
        currentPage: 0,
        keyword: '',
        data: rawData,
      }),
      onSortByKey: ({ data, sortType }) => (sortKey) => {
        const newSortType = sortType === 'asc' ? 'desc' : 'asc'
        return {
          sortKey,
          sortType: newSortType,
          data: orderDataByKey(data, sortKey, newSortType),
        }
      },
    },
  ),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const { rawData } = this.props
      const { rawData: nextRawData } = nextProps
      if (rawData.length !== nextRawData.length) {
        nextProps.refreshData(nextRawData)
      }
    },
  }),
  withProps(
    ({
      itemsPerPage,
      currentPage,
      data,
      setCurrentPage,
      amountOptions,
      onAmountOptionChange,
      keyword,
      onKeywordChange,
      clearKeyword,
      sortKey,
      sortType,
      onSortByKey,
    }) => {
      // console.group()
      // console.log('data', data)
      // console.log('currentPage', currentPage)
      // console.log('itemsPerPage', itemsPerPage)
      // console.groupEnd()
      return {
        pageCount: Math.ceil(data.length / itemsPerPage),
        filteredData: findPageData(
          data,
          itemsPerPage,
          currentPage,
        ),
        setCurrentPage,
        onAmountOptionChange,
        keyword,
        onKeywordChange,
        clearKeyword,
        sortKey,
        sortType,
        onSortByKey,
        amountOptions: amountOptions || defaultAmountOptions,
      }
    },
  ),
)



// WEBPACK FOOTER //
// ./src/hocs/bases/withTable.js